import { render, staticRenderFns } from "./OrderDetailComponent.vue?vue&type=template&id=4dbcf89e&scoped=true&"
import script from "./OrderDetailComponent.vue?vue&type=script&lang=js&"
export * from "./OrderDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailComponent.vue?vue&type=style&index=0&id=4dbcf89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbcf89e",
  null
  
)

export default component.exports